export default {"src":"/_next/static/image/public/images/ic_doctor_image_2.879d0241cadbfc3b39385bb6b004542b.svg","height":61,"width":58};